document.addEventListener("DOMContentLoaded", function () {

  // Hitta alla knappar som ska trigga mail
  const buttons = document.querySelectorAll('.mail-button');

  buttons.forEach(function(button) {
    button.addEventListener('click', function(e) {

      e.preventDefault(); // stoppar vanlig länk

      // Hitta närmaste sektion
      const section = button.closest('.mail-section');

      if (!section) {
        console.warn('Ingen .mail-section hittades');
        return;
      }

      // Hämta titel i sektionen
      const titleElement = section.querySelector('.mail-title');

      if (!titleElement) {
        console.warn('Ingen .mail-title hittades');
        return;
      }

      // Gör ämnesrad
      const subject = encodeURIComponent("Jobbansökan: " + titleElement.innerText);

      // Din mail
      const email = "info@nordicap.se";

      // (valfri) förifylld text i mailet
      const body = encodeURIComponent(
        "Hej!\n\nJag är intresserad av: " + titleElement.innerText + "\n"
      );

      // Skapa mailto-länk
      const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;

      // Öppna mailprogram
      window.location.href = mailtoLink;

    });
  });

});
